export const t = {
  en: {
    about: {
      title: "About me",
      hello: "Hello ! I'm",
      fullstack: "a french fullstack freelance engineer.",
      passionnate:
        "Passionnate about development since 2017, I really discovered frontend 3 years ago with",
      mobile:
        "I also started mobile development with Ionic at the same time, which leads me to",
      and: "and then",
      react:
        "I really enjoy working with React (or its environment like Preact or Next) for its architecture and its lightness.",
      working: "I'm currently working with",
      matmut:
        "a major french insurance company, as a freelance full-stack engineer. My main mission are building web applications for the company with React.js and .NET Core environment. ",
      comfortable:
        "I'm comfortable with many technlogies and here are the main ones :",
    },
    header: {
      about: "ABOUT ME",
      experiences: "EXPERIENCES",
      works: "SIDE PROJECTS",
      contact: "CONTACT ME",
    },
    landing: {
      hey: "Hey there!",
      I: "I'm",
      engineer: "engineer",
    },
    experiences: [
      {
        job: "Freelance Fullstack Engineer",
        corp: "@Matmut",
        color: "#000069",
        site: "https://www.matmut.fr/",
        missions: [
          "Web development for major French insurance company",
          ".NET 5.0, .Net Framework MVC",
          "React.js",
          "Docker, Git",
        ],
        period: "March 2023 - Present",
      },
      {
        job: "Apprentice Fullstack Engineer",
        corp: "@Attineos 🐘",
        color: "#FF9601",
        site: "https://www.attineos.com/",
        missions: [
          "Web development for major Swiss group - Helvetia Assurances",
          ".NET Core 3.1",
          "Angular 8+",
          "Scrum, CICD, Git flow",
        ],
        period: "October 2021 - December 2022",
      },
      {
        site: "https://www.econocom.com/",
        corp: "@Econocom",
        color: "#3E0E81",
        job: "Apprentice Fullstack Engineer",
        missions: [
          "Web and software development for Safran Group",
          "SqlServer database - T-SQL stored procedure",
          ".NETFramework or .NETCore Backend",
          "Angular or AngularJS Frontend",
        ],
        period: "October 2019 - October 2021",
      },
      {
        site: "https://www.digiworks.fr/",
        job: "Fullstack Developer Trainee",
        color: "#2A0030",
        corp: "@Digiworks Agency 🕹",
        missions: [
          "Backend development for a large French group with Symfony - Orange",
          "Conception and modelisation of database",
          "Configuration of the firewall",
          "VR Application development with Unity3D",
        ],
        period: "January 2019 - February 2019",
      },
      {
        site: "http://www.overspeed.fr/",
        corp: "@Overspeed ⚡️",
        color: "#142EF0",
        job: "Web Developer Trainee",
        missions: [
          "Database modelisation",
          "Conception of an API with the Laravel framework",
          "Realisation of a custom map, including POI and paths placement, with Leaflet.js",
        ],
        period: "March 2018 - June 2018",
      },
    ],
    works: {
      project: "Side Projects",
      smallProject: "Other small projects",
      witw: {
        title: "Where in the world is a collection of 6 geography games",
        desc: "The idea came out following a challenge on Frontend Mentor, I developed most of the application from scratch using React for the frontend, Firebase for the backend, Figma for the design and Tailwind for the CSS integration",
      },
      myconnect: {
        name: "My Connect",
        title:
          "My Connect is a web application targeting a group of people. It aims to organise events bringing together young adults (called Connect).",
        desc: "The idea of the application is to help the organization with a feed where people can post content ✉️, a shared calendar 📆, the notion of group, poll etc. The application has been designed and developed to work on Android, iOS, on tablet and smartphone format.",
      },
      ongoal: {
        title:
          "The OnGoal web application is a comprehensive tool tailored for organizing and managing amateur sports tournaments. It empowers users to create tournaments, input match scores, manage venues, and update match information efficiently.",
        desc: "From setting up new tournaments to maintaining match details, OnGoal streamlines the entire process for sports enthusiasts.",
      },
      ongoalmobile: {
        name: "On Goal Mobile ⚽︎ - WIP",
        title:
          "OnGoal is an application designed to streamline tournament management. Users can effortlessly access their teams, view scores, standings, match schedules, and various tournament-related details.",
        desc: "From tracking team performance to staying updated on upcoming matches, OnGoal provides a comprehensive platform for managing and engaging with tournaments effectively.",
      },
      myconnectmobile: {
        name: "My Connect Mobile",
        title:
          "My Connect is a mobile application 📱 developed for a group of people that organized event that assemble young adults (named Connect).",
        desc: "The idea of the application is to help the organization with a feed where people can posts content ✉️, a shared calendar 📆, the notion of group, poll etc. The application has been thought, designed and developed to work on Android, iOS, on tablet and smartphone format.",
      },
      disneywaittimes: {
        title:
          "Hybrid application that display the wait times for Walt Disney Studios et Disneyland Park Paris. Made with React Native and ❤️",
      },
      small: {
        ipaddress:
          "Single Page Application that gives you the information on american IP Address.",
        portfolio: "This portfolio has been designed and built by myself.",
        soccer:
          "Ionic App for mobile which display the standings, scorers and games of the 5 main soccer leagues",
        small: "Link to my small projects",
      },
    },
    contact: {
      title: "Contact me",
      name: "Name",
      email: "Email",
      message: "Message",
      send: "Send",
    },
    footer: {
      made: "Designed and built by Simon Mollet with React, Figma and ❤️.",
      inspired: "Inspired by Brittany Chiang.",
    },
  }, // English
  fr: {
    about: {
      hello: "Salut ! Je suis",
      title: "À propos",
      fullstack: "un développeur fullstack freelance.",
      passionnate:
        "Passionné par le développement depuis 2017, j'ai réellement découvert le développement frontend il y a 3 ans avec",
      mobile:
        "J'ai également commencé le développement mobile avec Ionic en parallèle, ce qui m'a conduit à",
      and: "et ensuite",
      react:
        "J'apprécie vraiment travailler avec React (ou son environnement comme Preact ou Next) pour son architecture et sa flexibilité.",
      working: "Je travaille actuellement pour la",
      matmut:
        "une grande compagnie d'assurance française, en tant que développeur fullstack freelance. Mes principales missions sont de développer des applications web pour l'entreprise avec React.js et l'environnement .NET Core.",
      comfortable:
        "Je suis à l'aise avec de nombreuses technologies et voici les principales :",
    },
    header: {
      about: "À PROPOS",
      experiences: "EXPERIENCES",
      works: "PROJETS",
      contact: "CONTACTEZ-MOI",
    },
    landing: {
      hey: "Salut!",
      I: "Je suis",
      engineer: "développeur",
    },
    experiences: [
      {
        job: "Développeur fullstack en freelance",
        corp: "@Matmut",
        color: "#000069",
        site: "https://www.matmut.fr/",
        missions: [
          "Développement web pour une grande compagnie d'assurance française",
          ".NET 5.0, .Net Framework MVC",
          "React.js",
          "Docker, Git",
        ],
        period: "Mars 2023 - Actuel",
      },
      {
        job: "Développeur fullstack en alternance",
        corp: "@Attineos 🐘",
        color: "#FF9601",
        site: "https://www.attineos.com/",
        missions: [
          "Développement web pour un grand groupe suisse - Helvetia Assurances",
          ".NET Core 3.1",
          "Angular 8+",
          "Scrum, CICD, Git flow",
        ],
        period: "Octobre 2021 - Décembre 2022",
      },
      {
        site: "https://www.econocom.com/",
        corp: "@Econocom",
        color: "#3E0E81",
        job: "Développeur fullstack en alternance",
        missions: [
          "Développement web et logiciel",
          "Base de données SqlServer - Procédures stockées T-SQL",
          "Backend .NETFramework ou .NETCore",
          "Frontend Angular ou AngularJS",
        ],
        period: "Octobre 2019 - Octobre 2021",
      },
      {
        site: "https://www.digiworks.fr/",
        job: "Développeur fullstack stagiaire",
        color: "#2A0030",
        corp: "@Digiworks Agency 🕹",
        missions: [
          "Développement backend pour un grand groupe français avec Symfony - Orange",
          "Conception et modélisation de base de données",
          "Configuration de pare-feu",
          "Développement d'une application VR avec Unity3D",
        ],
        period: "Janvier 2019 - Février 2019",
      },
      {
        site: "http://www.overspeed.fr/",
        corp: "@Overspeed ⚡️",
        color: "#142EF0",
        job: "Développeur web stagiaire",
        missions: [
          "Modélisation de base de données",
          "Conception d'une API avec le framework Laravel",
          "Réalisation d'une carte personnalisée, incluant des POI et des chemins, avec Leaflet.js",
        ],
        period: "Mars 2018 - Juin 2018",
      },
    ],
    works: {
      project: "Projets",
      smallProject: "Micro projets",
      witw: {
        title: "Where in the world est une collection de 6 jeux de géographie",
        desc: "L'idée est née suite à un challenge sur Frontend Mentor, j'ai développé la majorité de l'application de A à Z en utilisant React pour le frontend, Firebase pour le backend, Figma pour le design et Tailwind pour l'intégration CSS",
      },
      myconnect: {
        title:
          "My Connect est la version web de My Connect. Elle a pour but d'organiser des événements rassemblant des jeunes adultes (appelés Connect).",
        desc: "L'idée de l'application est d'aider l'organisation avec un fil d'actualité où les gens peuvent poster du contenu ✉️, un calendrier partagé 📆, la notion de groupe, sondage etc. L'application a été pensée, conçue et développée pour fonctionner sur Android, iOS, sur format tablette et smartphone.",
      },
      ongoalmobile: {
        name: "On Goal Mobile",
        title:
          "OnGoal est une application conçue pour simplifier la gestion des tournois. Les utilisateurs peuvent facilement accéder à leurs équipes, consulter les scores, les classements, les horaires des matchs et divers détails relatifs aux tournois.",
        desc: "De la performance des équipes à la mise à jour des matchs à venir, OnGoal offre une plateforme complète pour gérer et s'engager efficacement dans les tournois.",
      },
      myconnectmobile: {
        title:
          "My Connect est une application mobile ciblant un groupe de personnes. Elle a pour but d'organiser des événements rassemblant des jeunes adultes (appelés Connect).",
        desc: "L'idée de l'application est d'aider l'organisation avec un fil d'actualité où les gens peuvent poster du contenu ✉️, un calendrier partagé 📆, la notion de groupe, sondage etc. L'application a été pensée, conçue et développée pour fonctionner sur Android, iOS, sur format tablette et smartphone.",
      },
      disneywaittimes: {
        title:
          "Application hybride qui affiche les temps d'attente pour Walt Disney Studios et Disneyland Park Paris. Fait avec React Native et ❤️",
      },
      small: {
        // french
        ipaddress: "Application web qui affiche l'adresse IP de l'utilisateur",
        portfolio: "Ce portfolio a été designé et développé par mes soins",
        soccer:
          "Application mobile Ionic qui affiche les résultats, buteurs, statitstiques et classement des 5 ligues majeurs de football",
        small: "Lien vers tous mes micro projets",
      },
    },
    contact: {
      title: "Contactez-moi",
      name: "Nom",
      email: "Email",
      message: "Message",
      send: "Envoyer",
    },
    footer: {
      made: "Designé et développé par Simon Mollet avec React, Figma et ❤️",
      inspired: "Inspiré de Brittany Chiang",
    },
  }, // French
};
